import React, { useContext, useEffect } from 'react';
import { PageContext } from '@axiom/ui';

import { TermsOfUse } from '../components/TermsOfUse/TermsOfUse';

export const TermsOfUsePage = () => {
  const { setTitle } = useContext(PageContext);

  useEffect(() => {
    setTitle('Axiom Law - Terms of Use');
  }, []);

  return <TermsOfUse />;
};
